// extracted by mini-css-extract-plugin
export default {"container":"Frame_container__eJ6bE","content":"Frame_content__sZUhr"};